/** Billing plan tiers */
export const BILLING_PLAN_TIERS = ["starter", "pro", "enterprise"] as const;

export type BillingPlanTier = (typeof BILLING_PLAN_TIERS)[number];

export interface BillingPlanDefinition {
  tier: BillingPlanTier;
  label: string;
  /** Price per active worker per pay period in cents; null for custom/enterprise */
  pricePerWorkerCents: number | null;
  description: string;
}

export const BILLING_PLANS: Record<BillingPlanTier, BillingPlanDefinition> = {
  starter: {
    tier: "starter",
    label: "Starter",
    pricePerWorkerCents: 200,
    description: "$2 per active worker per pay period",
  },
  pro: {
    tier: "pro",
    label: "Pro",
    pricePerWorkerCents: 300,
    description: "$3 per active worker per pay period",
  },
  enterprise: {
    tier: "enterprise",
    label: "Enterprise",
    pricePerWorkerCents: null,
    description: "Custom pricing for large sites, integrations, advanced reports, and proof layer.",
  },
};

export const ACTIVE_WORKER_USAGE_TYPE = "active_workers";

export function isBillingPlanTier(value: string): value is BillingPlanTier {
  return (BILLING_PLAN_TIERS as readonly string[]).includes(value);
}

export function unitPriceCentsForPlan(tier: BillingPlanTier): number | null {
  return BILLING_PLANS[tier].pricePerWorkerCents;
}

export function estimateAmountCents(
  tier: BillingPlanTier,
  activeWorkers: number,
): number | null {
  const unitPrice = unitPriceCentsForPlan(tier);
  if (unitPrice == null) return null;
  return activeWorkers * unitPrice;
}

export function formatUsdFromCents(cents: number | null): string {
  if (cents == null) return "Custom";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(cents / 100);
}
